var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 -960 960 960"}},[_c('path',{attrs:{"d":"M80-80v-740q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 \n        18H240L80-80Zm134-220h606v-520H140v600l74-80Zm-74 0v-520 520Z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }